<div class="collector-tasks-container">
  <div class="loading-container" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div class="tasks-toolbar">
    <mat-checkbox
      class="show-completed-checkbox"
      [checked]="includeDone"
      (change)="onIncludeDoneChanged($event.checked)"
    >
      Show completed tasks
    </mat-checkbox>

    <div class="dc-date-filter-group">
      <label class="dc-date-filter-label" for="dc-date-filter">DC Date</label>
      <input
        id="dc-date-filter"
        type="text"
        class="dc-date-filter-input"
        placeholder="yyyy-MM-dd"
        [ngModel]="dcDateFilter"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onDcDateFilterChanged($event)"
      />
    </div>
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="tasks-table mat-elevation-z2"
  >
    <ng-container matColumnDef="dcType">
      <th mat-header-cell *matHeaderCellDef>DC Type</th>
      <td mat-cell *matCellDef="let task">{{ task.dcType }}</td>
    </ng-container>

    <ng-container matColumnDef="league">
      <th mat-header-cell *matHeaderCellDef>League</th>
      <td mat-cell *matCellDef="let task">{{ task.league ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="billingMonth">
      <th mat-header-cell *matHeaderCellDef>Billing Month</th>
      <td mat-cell *matCellDef="let task">{{ task.billingMonth ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="venueDatetime">
      <th mat-header-cell *matHeaderCellDef>Venue Datetime</th>
      <td mat-cell *matCellDef="let task">
        {{ task.venueDatetimeDisplay }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dcDatetime">
      <th mat-header-cell *matHeaderCellDef>DC Datetime</th>
      <td mat-cell *matCellDef="let task">
        <span [matTooltip]="task.dcDatetimeTooltip">{{ task.dcDatetimeDisplay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="etcDatetime">
      <th mat-header-cell *matHeaderCellDef>ETC Datetime</th>
      <td mat-cell *matCellDef="let task">
        <span [matTooltip]="task.etcDatetimeTooltip">{{ task.etcDatetimeDisplay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="roster">
      <th mat-header-cell *matHeaderCellDef>DC Roster</th>
      <td mat-cell *matCellDef="let task">
        <span class="roster-summary" *ngIf="isGmOrGoTask(task)">
          <span class="roster-count">
            {{ task.rosterAssigned }}/{{ task.rosterTotal }}
          </span>
          <span
            class="roster-warning-badge"
            *ngIf="isRosterIncomplete(task)"
            matTooltip="DC roster is not fully assigned"
            aria-label="DC roster is not fully assigned"
          >
            !
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="teams">
      <th mat-header-cell *matHeaderCellDef>Game</th>
      <td mat-cell *matCellDef="let task">
        <a
          class="game-link"
          [routerLink]="['/games', task.gameId, 'events']"
          target="_blank"
          rel="noopener noreferrer"
          [matTooltip]="task.gameId"
        >
          {{ task.homeTeam }} vs {{ task.awayTeam }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>Code</th>
      <td mat-cell *matCellDef="let task">{{ task.code }}</td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duration</th>
      <td mat-cell *matCellDef="let task">{{ task.duration ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="critical">
      <th mat-header-cell *matHeaderCellDef>Critical</th>
      <td mat-cell *matCellDef="let task">
        {{
          task.critical !== null && task.critical !== undefined
            ? task.critical
            : '—'
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let task">
        <select
          class="status-native-select"
          [ngModel]="task.status"
          [ngClass]="{
            'status-yes': task.status === 'yes',
            'status-in_progress': task.status === 'in_progress',
            'status-no': task.status === 'no',
            'status-done': task.status === 'done'
          }"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onStatusChanged(task, $event)"
        >
          <option
            *ngFor="let statusOption of statusOptions"
            [ngValue]="statusOption.value"
          >
            {{ statusOption.label }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let task">
        <button
          mat-button
          type="button"
          class="expand-button"
          (click)="toggleExpanded(task)"
          [attr.aria-label]="
            isExpanded(task) ? 'Collapse task details' : 'Expand task details'
          "
        >
          <mat-icon>{{
            isExpanded(task) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          }}</mat-icon>
          <span>{{ isExpanded(task) ? 'Collapse' : 'Expand' }}</span>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let task"
        [attr.colspan]="displayedColumns.length"
        class="detail-cell"
      >
        <div class="task-detail-wrapper" *ngIf="isExpanded(task)">
          <mat-tab-group class="task-detail-tabs">
            <mat-tab label="DC Roster">
              <ng-template matTabContent>
                <div class="task-tab-content">
                  <app-dc-roster
                    [gameId]="task.gameId"
                    [readOnly]="isRosterReadOnly(task)"
                    [saveMode]="'immediate'"
                    (rosterSummaryChange)="
                      onRosterSummaryChanged(task.gameId, $event)
                    "
                  ></app-dc-roster>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab *ngIf="shouldShowEssentialsTab(task)" label="Essentials">
              <ng-template matTabContent>
                <div class="task-tab-content">
                  <ng-container *ngTemplateOutlet="expandedTaskDetailsStatus"></ng-container>

                  <ng-container
                    *ngIf="!expandedTaskDetailsLoading && !expandedTaskDetailsError"
                  >
                    <app-game-details-card-essentials
                      *ngIf="expandedTaskGame as game"
                      [game]="game"
                      [gameUnmodified]="expandedTaskGameUnmodified"
                      [saving]="expandedTaskGameSaving"
                      [seasons]="seasons"
                      [leagues]="leagues"
                      [teams]="expandedTaskTeams"
                      (seasonChange)="onExpandedTaskSeasonChange($event)"
                      (idTypeChange)="onExpandedTaskIdTypeChange($event)"
                      (leagueChange)="onExpandedTaskLeagueChange($event)"
                      (homeTeamChange)="onExpandedTaskHomeTeamChange($event)"
                      (awayTeamChange)="onExpandedTaskAwayTeamChange($event)"
                      (essentialsChange)="onExpandedTaskEssentialsChange()"
                    ></app-game-details-card-essentials>
                  </ng-container>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab *ngIf="shouldShowVideosTab(task)" label="Videos">
              <ng-template matTabContent>
                <div class="task-tab-content">
                  <ng-container *ngTemplateOutlet="expandedTaskDetailsStatus"></ng-container>

                  <ng-container
                    *ngIf="!expandedTaskDetailsLoading && !expandedTaskDetailsError"
                  >
                    <app-game-details-videos-card
                      *ngIf="expandedTaskGame as game"
                      [game]="game"
                      [saving]="expandedTaskGameSaving"
                      (detailsChange)="onExpandedTaskVideoDetailsChange()"
                      (addVideo)="onExpandedTaskAddVideo($event)"
                      (removeVideo)="onExpandedTaskRemoveVideo($event)"
                      (downloadVideo)="onExpandedTaskDownloadVideo($event)"
                      (videoUrlChange)="onExpandedTaskVideoUrlChange($event)"
                      (uploadVideo)="onExpandedTaskUploadVideo($event)"
                      (liveStreamAdded)="onExpandedTaskLiveStreamAdded($event)"
                    ></app-game-details-videos-card>
                  </ng-container>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let task; let dataIndex = dataIndex; columns: displayedColumns"
      class="task-row hoverable-table-row"
      [class.alt-task-row]="dataIndex % 2 === 1"
    ></tr>
    <tr
      mat-row
      *matRowDef="let task; columns: detailRowColumns"
      class="detail-row"
      [class.hidden-detail-row]="!isExpanded(task)"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell empty-row" [attr.colspan]="displayedColumns.length">
        No tasks assigned.
      </td>
    </tr>
  </table>

  <mat-paginator
    [length]="taskCount"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChanged($event)"
  ></mat-paginator>

  <h3 class="open-tasks-heading">Open Tasks</h3>

  <div class="open-tasks-loading-container" *ngIf="openTasksLoading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <table
    mat-table
    [dataSource]="openTasksDataSource"
    class="tasks-table mat-elevation-z2"
  >
    <ng-container matColumnDef="dcType">
      <th mat-header-cell *matHeaderCellDef>DC Type</th>
      <td mat-cell *matCellDef="let task">{{ task.dcType }}</td>
    </ng-container>

    <ng-container matColumnDef="league">
      <th mat-header-cell *matHeaderCellDef>League</th>
      <td mat-cell *matCellDef="let task">{{ task.league ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="billingMonth">
      <th mat-header-cell *matHeaderCellDef>Billing Month</th>
      <td mat-cell *matCellDef="let task">{{ task.billingMonth ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="venueDatetime">
      <th mat-header-cell *matHeaderCellDef>Venue Datetime</th>
      <td mat-cell *matCellDef="let task">
        {{ task.venueDatetimeDisplay }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dcDatetime">
      <th mat-header-cell *matHeaderCellDef>DC Datetime</th>
      <td mat-cell *matCellDef="let task">
        <span [matTooltip]="task.dcDatetimeTooltip">{{ task.dcDatetimeDisplay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="etcDatetime">
      <th mat-header-cell *matHeaderCellDef>ETC Datetime</th>
      <td mat-cell *matCellDef="let task">
        <span [matTooltip]="task.etcDatetimeTooltip">{{ task.etcDatetimeDisplay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="roster">
      <th mat-header-cell *matHeaderCellDef>DC Roster</th>
      <td mat-cell *matCellDef="let task">
        <span class="roster-summary" *ngIf="isGmOrGoTask(task)">
          <span class="roster-count">
            {{ task.rosterAssigned }}/{{ task.rosterTotal }}
          </span>
          <span
            class="roster-warning-badge"
            *ngIf="isRosterIncomplete(task)"
            matTooltip="DC roster is not fully assigned"
            aria-label="DC roster is not fully assigned"
          >
            !
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="teams">
      <th mat-header-cell *matHeaderCellDef>Game</th>
      <td mat-cell *matCellDef="let task">
        <a
          class="game-link"
          [routerLink]="['/games', task.gameId, 'events']"
          target="_blank"
          rel="noopener noreferrer"
          [matTooltip]="task.gameId"
        >
          {{ task.homeTeam }} vs {{ task.awayTeam }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>Code</th>
      <td mat-cell *matCellDef="let task">{{ task.code }}</td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duration</th>
      <td mat-cell *matCellDef="let task">{{ task.duration ?? '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="critical">
      <th mat-header-cell *matHeaderCellDef>Critical</th>
      <td mat-cell *matCellDef="let task">
        {{
          task.critical !== null && task.critical !== undefined
            ? task.critical
            : '—'
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let task">
        <select
          class="status-native-select status-open"
          [ngModel]="task.status || 'open'"
          [ngModelOptions]="{ standalone: true }"
          disabled
        >
          <option [ngValue]="'open'">Open</option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="take">
      <th mat-header-cell *matHeaderCellDef>Take</th>
      <td mat-cell *matCellDef="let task">
        <button mat-stroked-button color="primary" (click)="onTakeTask(task)">
          Take
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="openTasksDisplayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let task; let dataIndex = dataIndex; columns: openTasksDisplayedColumns"
      class="task-row hoverable-table-row"
      [class.alt-task-row]="dataIndex % 2 === 1"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell empty-row" [attr.colspan]="openTasksDisplayedColumns.length">
        No open tasks available.
      </td>
    </tr>
  </table>

  <mat-paginator
    [length]="openTasksCount"
    [pageSize]="openTasksPageSize"
    [pageIndex]="openTasksPageIndex"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onOpenTasksPageChanged($event)"
  ></mat-paginator>

  <ng-template #expandedTaskDetailsStatus>
    <div
      class="expanded-task-loading"
      *ngIf="expandedTaskDetailsLoading"
    >
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <p class="expanded-task-error" *ngIf="expandedTaskDetailsError as error">
      {{ error }}
    </p>
  </ng-template>
</div>
